import { WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';
import { WORKSPACE_PANEL_EDGE_PADDING } from '~/constants/panelWidths';

/**
 * Trailing gap for *max width* only. A maximized card at the left padding then sits just outside
 * the dock snap threshold. Narrow cards still use edge padding at max left so they can be dragged
 * into the snap zone; viewport-max cards use the same trailing clearance as max width.
 */
export const WORKSPACE_AGENT_PANEL_FLOAT_MIN_DISTANCE_TO_RIGHT_PX = WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX + 1;

export const getWorkspaceAgentPanelFloatMaxWidth = (
  viewportWidth: number,
  left = WORKSPACE_PANEL_EDGE_PADDING,
): number => viewportWidth - left - WORKSPACE_AGENT_PANEL_FLOAT_MIN_DISTANCE_TO_RIGHT_PX;

export const getWorkspaceAgentPanelFloatMaxLeft = (viewportWidth: number, width: number): number => {
  const trailingClearance =
    width >= getWorkspaceAgentPanelFloatMaxWidth(viewportWidth)
      ? WORKSPACE_AGENT_PANEL_FLOAT_MIN_DISTANCE_TO_RIGHT_PX
      : WORKSPACE_PANEL_EDGE_PADDING;

  return viewportWidth - width - trailingClearance;
};

export const getWorkspaceAgentPanelFloatWidthViewportBound = (viewportWidth: number): number =>
  getWorkspaceAgentPanelFloatMaxWidth(viewportWidth);
